import { Injectable } from '@angular/core';
import {Match} from '../shared/match';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class HomeService {
  musicPointUrl: string = environment.dashboardApiUrl;

  getNumberOfMatches(): Observable<Match> {
    const url = this.musicPointUrl + '/stats/matched';
    return this.http.get<Match>(url);
  }
  getLastMatchDate(): Observable<Match> {
    const url = this.musicPointUrl + '/stats/lastMatch';
    return this.http.get<Match>(url);
  }
  getTotalPlays(): Observable<Match> {
    const url = this.musicPointUrl + '/stats/total';
    return this.http.get<Match>(url);
  }
  getModified(): Observable<Match> {
    const url = this.musicPointUrl + '/stats/modified';
    return this.http.get<Match>(url);
  }
  constructor( private http: HttpClient ) { }

}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts